import { render, staticRenderFns } from "./TemperatureView.vue?vue&type=template&id=4a827d68&scoped=true&"
import script from "./TemperatureView.vue?vue&type=script&lang=ts&"
export * from "./TemperatureView.vue?vue&type=script&lang=ts&"
import style0 from "./TemperatureView.vue?vue&type=style&index=0&id=4a827d68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a827d68",
  null
  
)

export default component.exports